import {
  Typography,
  SimpleModal,
  Link,
  styled,
} from '@nextiva/next-ui-components';
import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

const StyledSimpleModal = styled(SimpleModal)`
  div.MuiDialog-paper {
    width: 670px;
  }

  button.MuiButton-sizeMedium {
    padding: 12px 24px;
  }
`;
const StyledLink = styled(Link)`
  &.MuiTypography-root {
    color: ${({ theme }) => theme.palette.primary.main};
  }
  &:hover {
    text-decoration: none;
  }
`;
const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;

const RegistrationModal: FC<DialogProps> = ({
  open,
  onClose,
  handleSMSChange,
}) => {
  const history = useHistory();

  return (
    <StyledSimpleModal
      confirmText="Register now"
      onClose={onClose}
      open={open}
      title="Enable text messaging"
      cancelText="Cancel"
      tertiaryText="Enable internal messaging"
      confirmButtonProps={{
        onClick: () => history.push('/messaging?openCampaignDialog=true'),
      }}
      cancelButtonProps={{ onClick: onClose }}
      tertiaryButtonProps={{ onClick: handleSMSChange }}
      data-testid="PlatformAdminUI-RegistrationModal"
    >
      <StyledTypography sx={{ paddingTop: '8px' }} variant="body2">
        Business messaging registration is mandatory for external messaging.
        Learn more about it from{' '}
        <StyledLink
          href="https://www.nextiva.com/support/articles/sms-faqs.html"
          target="_blank"
          rel="noopener"
          data-testid="PlatformAdminUI-RegistrationModal-LearnMore"
        >
          Business Messaging Registration FAQs.
        </StyledLink>{' '}
        To continue with the registration process, please select ‘Register now’.
      </StyledTypography>
      <StyledTypography sx={{ margin: '16px 0 -8px 0' }} variant="body2">
        You can continue messaging internally to your teammates.
      </StyledTypography>
    </StyledSimpleModal>
  );
};

export default RegistrationModal;
